import React from 'react';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, message }) => {
  if (!isOpen) return null;

  return (
    <div className={`modal-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {/* X nell'angolo in alto a destra */}
        <button className="modal-close-button" onClick={onClose}>
          ×
        </button>
        
        <div className="modal-header">
          <h2>Conferma Eliminazione</h2>
        </div>
        <div className="modal-body">
          <div className="warning-icon">
            <i className="fas fa-exclamation-triangle"></i>
          </div>
          <p>{message || "Sei sicuro di voler eliminare questo elemento?"}</p>
        </div>
        <div className="modal-actions">
          <button 
            type="button" 
            className="btn btn-secondary" 
            onClick={onClose}
          >
            Annulla
          </button>
          <button 
            type="button" 
            className="btn btn-danger" 
            onClick={onConfirm}
          >
            Elimina
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
